module.exports = __webpack_public_path__ + "2a6908708994a6182cbbf9065b918ea9.fbx";